import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
let originPush = Router.prototype.push
let originReplace = Router.prototype.replace
Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => {
    }, () => {
    })
  }
}
Router.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject)
  } else {
    originReplace.call(this, location, () => {
    }, () => {
    })
  }
}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/about',
          name: 'about',
          component: resolve => require(['@/view/about'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/wedding-information',
          name: 'wedding-information',
          component: resolve => require(['@/view/wedding-information'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/contact',
          name: 'contact',
          component: resolve => require(['@/view/contact'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        }, {
          path: '/disclaimer',
          name: 'disclaimer',
          component: resolve => require(['@/view/disclaimer'], resolve),
          meta: {
            title: '免责声明'
          }
        }, {
          path: '/terms-and-conditions',
          name: 'terms-and-conditions',
          component: resolve => require(['@/view/terms-and-conditions'], resolve),
          meta: {
            title: '使用条款'
          }
        },{
          path: '/privacy-policy',
          name: 'privacy-policy',
          component: resolve => require(['@/view/privacy-policy'], resolve),
          meta: {
            title: '私隐政策及声明'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js